import { httpService } from '~/Services/Service';
import { salvarEmExcel } from '~/Utils/Helpers';

// W-0613 — Posição Sintética Carteira a Receber
// Fonte backend: Setpar.APIRest/Controllers/Relatorios/PosicaoSinteticaCarteiraReceberController.cs
// RoutePrefix: "relatorios/posicao-sintetica-carteira-receber" (sem /api/ — APIBASE já cobre).
// Server-side (sem SSRS/.rdl): /gerar devolve o conteúdo de ##corr como grid JSON.

const BASE = '/relatorios/posicao-sintetica-carteira-receber';

const listarMoedas = () => httpService.get(`${BASE}/moedas`);

const listarGruposEmpresa = () => httpService.get(`${BASE}/grupos-empresa`);

// JSON snake_case global (SnakeCaseNamingStrategy): CodigosGrupoEmpresa -> codigos_grupo_empresa,
// CodigoMoeda -> codigo_moeda, LevantarCorrecao -> levantar_correcao.
const gerar = ({ codigosGrupoEmpresa, codigoMoeda, levantarCorrecao }) =>
  httpService.post(`${BASE}/gerar`, {
    codigos_grupo_empresa: codigosGrupoEmpresa,
    codigo_moeda: codigoMoeda,
    levantar_correcao: levantarCorrecao,
  });

// Padrão ExportadorController: envia o `resultado` já carregado pelo /gerar como payload
// (evita re-executar a query). O JSON snake_case do /gerar é o mesmo formato esperado pelo
// POST /exportar-excel (round-trip Newtonsoft).
const exportarExcel = (resultado) =>
  salvarEmExcel(resultado, `${BASE}/exportar-excel`);

export default { listarMoedas, listarGruposEmpresa, gerar, exportarExcel };
